// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  productType: 'INSIGHTS',
  productName: 'Pulse',
  type: 'test',
  apiUrl: 'https://test-insights-service.sarasanalytics.com',
  subscriptionApiUrl:
    'https://test-subscription-service.sarasanalytics.com/v1/api',
  insightsSubscriptionApiUrl:
    'https://test-insights-service.sarasanalytics.com',
  userServiceApiUrl: `https://test-user-service.sarasanalytics.com/v1/api/user`,
  datonApiUrl: 'https://testwebapi.sarasanalytics.com',
  supportApiUrl: 'https://test-support-service.sarasanalytics.com/v1/api',
  USER_ID: 1,
  PULSE_ID: 529319,
  agGridLicense:
    'CompanyName=Saras Analytics LLC,LicensedGroup=Saras Analytics,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=1,AssetReference=AG-019027,ExpiryDate=14_September_2022_[v2]_MTY2MzExMDAwMDAwMA==c5d541762d7390c2be2157dbfe53d87b',
  firebaseConfig: {
    apiKey: 'AIzaSyDfh2bgYUAZPYB9Y0z-bS77__gtEbaKJPk',
    authDomain: 'daton-210514.firebaseapp.com',
    databaseURL: 'https://daton-210514.firebaseio.com',
    projectId: 'daton-210514',
    storageBucket: 'daton-210514.appspot.com',
    messagingSenderId: '407696326090',
    appId: '1:407696326090:web:200ec20ecf19250918a333',
  },
  filestackConfig: {
    apiKey: 'ARlI6nnkOSJqOMEJo5Clpz',
    appSecret: '5HBLGKB3RBAKLMQ35HUFTYQN3A',
  },
  allowTemplatesFeatureOnlyForTemplateAdmin: true,
  ALLOWED_TEMPLATE_ROLES: ['TemplateAdmin', 'Admin'],
  RESTRICTED_TEMPLATE_PLANS: [
    'starter',
    'growth',
    'lite',
    'starter_yearly',
    'growth_yearly',
    'business_yearly',
    'liteyearly',
    'trial',
  ],
  ALLOWED_TEMPLATE_PLANS: ['enterprise', 'enterprise_yearly'],
  ALLOWED_STUDIO_ROLES: ['TemplateAdmin', 'Admin'],
  ALLOWED_SUBSCRIPTION_ROLES: [
    'OrganizationAdmin',
    'Admin',
    'OrganizationUser',
    'SarasAdmin',
  ],
  ALLOWED_OLD_SUBSCRIPTION_ROLES: ['OrganizationAdmin', 'Admin'],
  STUDIO_SOURCE_TYPE: 'TESTSOURCETYPE',
  THRESHOLD: 100000,
  PRODUCTS: {
    DATON: 'https://testweb.sarasanalytics.com/auth',
    PULSE: 'https://test-insights.sarasanalytics.com/auth',
    INSIGHTS: 'https://test-insights.sarasanalytics.com/auth',
    SARAS: 'https://test-accounts.sarasanalytics.com/products',
    IQ: 'https://testiq.sarasanalytics.com/auth',
  },
  PRODUCT_PRICING: {
    DATON: 'https://testweb.sarasanalytics.com/u/pricing',
    PULSE: 'https://test-insights.sarasanalytics.com/subscription/overview',
    INSIGHTS: 'https://test-insights.sarasanalytics.com/subscription/overview',
    SARAS: 'https://testweb.sarasanalytics.com/u/pricing',
    IQ: 'https://testiq.sarasanalytics.com/auth',
  },
  posthog: {
    apiKey: 'phc_8v1FDOCq0Hi53qfRoV5e63Mpv0f6mfBwpprer0vhmN6',
    apiHost: 'https://replay.sarasanalytics.com',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
